import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Placeholder = styled.div`
	color: ${(props) => props.theme.colors.slateBlue};
	font-size: 16px;
	opacity: 0.5;
`;

export default function PlaceholderDisplay(props: { text?: string }) {
	const { t } = useTranslation();

	return <Placeholder>{props.text ?? t('evaluation.submission.answerPlaceholder')}</Placeholder>;
}
